export const buildPdsUrl = (
  baseUrl: string | undefined,
  articleId: string | undefined,
  colorId: string | undefined,
): string | undefined => {
  if (articleId !== undefined && articleId !== null && articleId !== '') {
    return `${baseUrl}?variant=${articleId}`;
  }
  if (colorId !== undefined && colorId !== null && colorId !== '') {
    return `${baseUrl}?variant=${colorId}`;
  }
  return baseUrl;
};
